import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Box, CircularProgress, Typography } from "@mui/material";
import DataTable from "react-data-table-component";

import DashboardMenu from "../../commonComponents/DashboardMenu";
import useStyles from "../DashboardAuction/dashAuction.style";
import {
  JoinRequestChip,
  joinRequestDetail,
  joinRequestState,
} from "../../commonComponents/JoinRequestStatus";
import { getMyJoinRequestsAPI } from "../../../api/joinRequestsAPI";

// what follows the status, e.g. "Lots 3, 4, 5 · accept terms"
export const myRequestNote = (row) => {
  const state = joinRequestState(row, row.isParticipant);
  if (state === "APPROVED" || state === "ADDED") {
    const lots = row.allottedLotNumbers?.length
      ? `Lots ${row.allottedLotNumbers.join(", ")}`
      : "Lots to be allotted";
    return row.acceptedTerms ? lots : `${lots} · accept terms`;
  }
  return joinRequestDetail(row);
};

// A bidder's requests to participate, one row per auction: where each stands
// now, and a link to the auction
const MyRequests = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMyJoinRequestsAPI()
      .then(({ data }) => setRows(data || []))
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  }, []);

  const columns = [
    {
      name: "Auction",
      selector: (row) => row.auctionTitle,
      cell: (row) => <span style={{ fontWeight: 500 }}>{row.auctionTitle}</span>,
      sortable: true,
      grow: 2,
    },
    {
      name: "Organiser",
      selector: (row) => row.organiserName || "",
      sortable: true,
    },
    {
      name: "Requested on",
      selector: (row) => row.createdAt,
      format: (row) => moment(row.createdAt).format("D MMM YYYY"),
      sortable: true,
    },
    {
      name: "Status",
      grow: 2,
      cell: (row) => (
        <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap", py: 1 }}>
          <JoinRequestChip state={joinRequestState(row, row.isParticipant)} />
          <span>{myRequestNote(row)}</span>
        </Box>
      ),
    },
    {
      name: "",
      cell: (row) => (
        <a
          href={`#/auctions/${row.eventId}`}
          onClick={(event) => {
            event.preventDefault();
            navigate(`/auctions/${row.eventId}`);
          }}
        >
          Open auction
        </a>
      ),
    },
  ];

  return (
    <div className={classes.section}>
      <div className="container">
        <div className={classes.Dashboard}>
          <div className={classes.dashboardCard}>
            <DashboardMenu />
            <div className={classes.dashboardCards}>
              <Typography variant="h5" sx={{ fontWeight: 700, my: 2 }}>
                My requests
              </Typography>
              {loading ? (
                <CircularProgress />
              ) : (
                <DataTable
                  columns={columns}
                  data={rows}
                  pagination
                  responsive
                  noDataComponent={
                    <Box sx={{ p: 3, color: "#4B5563" }}>
                      You haven't asked to join any auction yet. On an auction's
                      page, use "Request to participate".
                    </Box>
                  }
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyRequests;
